module.exports = __webpack_public_path__ + "983d9e282119c71b1eed5af839a7c092.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/tree-bottom-s.png
// module id = 2025
// module chunks = 0